<template>
    <!-- 商品删除 -->
    <div>
        <content-view>
            <div class="wrap-container-in mb16">
                <div class="text-primary font-bigger">当前使用仓储数据：{{sysTypeEnum[storageSystemInfo.systemType]}}</div>
            </div>
            <div class="wrap-container-in">
                <div class="font-big">
                    系统切换（点击进行选择切换）：
                </div>
                <a-radio-group @change="change" :value="sysType" :disabled="!getBtnByAuth('storageSysSwitchButton')">
                    <div class="mt16">
                        <a-radio :value="0">金蝶系统数据（包含金蝶仓库数据/物料数据）</a-radio>
                            <a-button v-if="sysType === 0" class="ml8" size="small" type="primary" @click="showSwitchOrganization">切换机构</a-button>
                            <div class="text-primary mt8 mb8" v-if="storageSystemInfo.organizationName">当前所取金蝶系统机构为：{{storageSystemInfo.organizationName}}</div>
                    </div>
                    <!-- <div class="mt16">
                        <a-radio :value="1">系统自有数据（包含仓库管理/物料管理）</a-radio>
                    </div> -->
                </a-radio-group>
            </div>
            <a-modal
            centered
            title="切换确认"
            :width="500"
            :visible="visibleSwitchComfirm"
            @ok="switchOrganizationOk"
            @cancel="cancel"
            :confirmLoading="confirmLoading"
            >
                <a-form :form="form" layout="inline">
                    <div>
                        确认将仓储数据切换至“<span class="text-primary">{{sysTypeEnum[sysType]}}</span>”？
                    </div>
                    <template v-if="sysType === 0">
                        <div class="mt16">
                            
                            <a-form-item label="请选择金蝶系统对应机构">
                                <a-select :options="kingDiskOrganizationList" style="width: 250px;" placeholder="请选择" v-decorator="['organizationId', {rules:[{required: true, message: '请选择'}]}]"></a-select>
                            </a-form-item>
                        </div>
                    </template>
                </a-form>
            </a-modal>
            <a-modal
            centered
            :closable="false"
            :width="400"
            :visible="visibleSwitching"
            :footer="false"
            >
                <div class="text-center">
                    <div class="font-bigger text-primary mb16">系统切换中</div>
                    <div>请稍后...</div>
                </div>
            </a-modal>
            <a-modal
            centered
            :closable="false"
            :width="200"
            :visible="visibleResult"
            :footer="false"
            >
                <div class="text-center">
                    <div class="font-bigger text-primary">系统切换成功</div>
                </div>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: 'storageSysSwitch',
        components: {},
        props: {},
        data() {
            return {
                sysType: undefined,
                sysTypeEnum: ['金蝶系统数据', '系统自有数据', '请先去指定使用金蝶系统还是自有系统'],
                visibleSwitchComfirm: false,
                visibleSwitching: false,
                visibleResult: false,
                confirmLoading: false,
                kingDiskOrganizationList: [],
                storageSystemInfo: {
                    systemType: 2
                }
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            change(e) {
                this.sysType = e.target.value;
                this.visibleSwitchComfirm = true;
            },
            cancel() {
                this.visibleSwitchComfirm = false;
                setTimeout(() => {
                    this.form.resetFields();
                }, 300);
            },
            /**
             * @systemSwitching 获取仓库系统类型
             */
            systemSwitching() {
                if (!this.shopId || Number(this.shopId) === -1) {
                    this.sysType = undefined;
                    this.storageSystemInfo = {
                        systemType: 2
                    };
                    return false;
                }
                this.$api.newStorage.systemSwitching({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res && res.systemType !== 2) {
                        this.sysType = res.systemType;
                    }
                    this.storageSystemInfo = res;
                }).catch(err => {
                    if (err && err.response && err.response.data && err.response.data.code === 101) {
                        this.$message.destroy();
                    }
                    this.sysType = undefined;
                    this.storageSystemInfo = {
                        systemType: 2
                    }
                });
            },
            /**
             * @getkingDiskOrganization 获取组织列表
             */
            getkingDiskOrganization() {
                if(!this.shopId) return
                this.$api.newStorage.kingDiskOrganization({}).then(res => {
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.organizationName;
                    });
                    this.kingDiskOrganizationList = res;
                });
            },
            /**
             * @switchOrganizationOk 切换组织确认
             */
            switchOrganizationOk() {
                this.form.validateFields((errors, values) => {
                    if (this.confirmLoading) {
                        return false;
                    }
                    if (Boolean(errors)) return;
                    this.confirmLoading = true;
                    this.visibleSwitching = true;
                    this.$api.newStorage.otherBinding({
                        body: {
                            organizationId: this.sysType === 0 ? values.organizationId : undefined,
                            shopId: this.shopId,
                            type: Boolean(this.shopId) !== -1 ? this.sysType : undefined,
                            userId: this.userInfo.id,
                            account: this.userInfo.account,
                            username: this.userInfo.name
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.visibleSwitchComfirm = false;
                        setTimeout(() => {
                            this.form.resetFields();
                            //切换仓库成功弹窗展示
                            setTimeout(() => {
                                this.visibleSwitching = false;
                                setTimeout(() => {
                                    this.visibleResult = true;
                                    setTimeout(() => {
                                        this.visibleResult = false;
                                        this.systemSwitching();
                                    }, 1000);
                                }, 300);
                            }, 3000);
                            //
                        }, 300);
                    }).catch(err => {
                        this.confirmLoading = false;
                        this.visibleSwitching = false;
                    });
                });
            },
            showSwitchOrganization() {
                this.visibleSwitchComfirm = true;
                if (this.storageSystemInfo.id) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({organizationId: this.storageSystemInfo.organizationId});
                    });
                }
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getkingDiskOrganization();
            this.systemSwitching();
        },
        watch: {
            shopId() {
                this.getkingDiskOrganization();
                this.systemSwitching();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.delete-apply-detail-info {
    background-color: #efefef;
    padding: 16px;
}
</style>
